export default __webpack_public_path__ + "static/media/SmartRecruiters_log_bleu.1bbc47ff.png";